import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpHeaders } from '@angular/common/http';
import { HttpClient, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { catchError, retry, map, tap } from 'rxjs/operators';
import { Observable, throwError, BehaviorSubject } from 'rxjs';
import { CurrencyConversionProperties, CurrencyObject, CurrencyInfo } from '../Models/CurrencyConversionProperties';

@Injectable({
  providedIn: 'root'
})

export class CurrencyConversionService {
  baseUrl = environment.baseUrl;
  backSystemUrl = environment.backSystemBaseUrl;
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  }
  constructor(private http: HttpClient) {

  }



  getCurrencyInformation(): Observable<CurrencyInfo[]> {
    return this.http.get<CurrencyInfo[]>(this.baseUrl + '/Currency/getCurrencyInfo', this.httpOptions).pipe(map((data: any) => {
      return data;
    }), catchError(error => { return throwError(error); }));
  }
  updateCurrencyInformation(obj: CurrencyConversionProperties): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/Currency/updateCurrencyInfo', obj, this.httpOptions).pipe(map((data: any) => {
      return data;
    }), catchError(error => { return throwError(error); }));
  }
  getAgencyCurrencyInformation(agencyid: string): Observable<CurrencyInfo> {
    return this.http.get<CurrencyInfo>(this.baseUrl + '/Currency/getAgencyCurrencyInfo/' + agencyid, this.httpOptions).pipe(map((data: any) => {
      return data;
    }), catchError(error => { return throwError(error); }));
  }

  getCurrencyByValue(curObj: CurrencyObject): Observable<CurrencyConversionProperties> {
    return this.http.post<CurrencyConversionProperties>(this.baseUrl + '/Currency/getCurrencyByCode', curObj, this.httpOptions).pipe(map((data: any) => {
      return data;
    }), catchError(error => { return throwError(error); }));
  }





}
